import Vue from 'vue'
import store from '../store'

import Router from 'vue-router'

import App from '@/App'
import Login from '@/views/Login'
import MainView from '@/views/MainView'
import NewInvoice from '@/views/NewInvoice'
import ViewInvoice from '@/views/InvoiceView'

Vue.use(Router)

const router = new Router({
  routes: [
    { 
      path: '/', component: App, children: [
        { path: '/', name: 'index', component: MainView },
        { path: '/invoices/new', name: 'new', component: NewInvoice },
        { path: '/invoices/:invoice_id', name: 'view', component: ViewInvoice, props: true }
      ] 
    },
    { path: '/login', name: 'login', component: Login },
  ]
})

const debug = false
if (!debug) {
  router.beforeEach(function (to, from, next) {
    if ((to.name !== 'login') && store.state.user.token === null) next({ name: 'login', query: { next: to.path } })
    else if ((to.name === 'login') && store.state.user.token) next({ name: 'index' })
    else {
      next()
    }
  })
}

export default router


// WEBPACK FOOTER //
// ./src/router/index.js